import { Box, styled, Typography } from "@mui/material"
import type React from "react"
import { forwardRef, useImperativeHandle, useRef } from "react"
import { useReactToPrint } from "react-to-print"
import PhcAshcaLarge from "../assets/svg-components/PhcAshcaLarge"

const PrintContainer = styled(Box)({
  "@media print": {
    /* these properties default background graphics **/
    webKitPrintColorAdjust: "exact",
    colorAdjust: "exact",
    printColorAdjust: "exact",
    margin: "0 20px 20px 20px",
    "@page": {
      size: "8.5in 11in",
      margin: "8mm 0mm 0mm 0mm",
      border: "none !important",
    },
  },
})

export interface PrintHandle {
  handlePrintClick: () => void
}

interface PrintTemplateProps {
  children: React.ReactNode
  legalStatement?: string
}

export const PrintTemplate = forwardRef<PrintHandle, PrintTemplateProps>(
  ({ children, legalStatement }, ref) => {
    const componentRef = useRef<Element | Text>(null)

    const handlePrint = useReactToPrint({
      contentRef: componentRef,
    })

    useImperativeHandle(ref, () => ({
      handlePrintClick() {
        handlePrint()
      },
    }))

    return (
      <PrintContainer ref={componentRef}>
        <Box
          sx={{
            display: "none",
            displayPrint: "flex",
            justifyContent: "center",
            padding: 2,
          }}
        >
          <PhcAshcaLarge style={{ height: 40, width: "auto" }} />
        </Box>
        {children}
        <Box
          sx={{
            paddingTop: 5,
            display: "none",
            displayPrint: legalStatement && "block",
          }}
        >
          <Typography variant="h3">Confidential and Proprietary</Typography>
          <Typography
            variant="body2"
            sx={{
              fontStyle: "italic",
            }}
          >
            {legalStatement}
          </Typography>
        </Box>
      </PrintContainer>
    )
  }
)

PrintTemplate.displayName = "PrintTemplate"
